import React from 'react';
import { Helmet } from 'react-helmet';
import { LINKS } from '../config/links';

const SEOHead = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Restaurant",
    "name": "Le Paradis – Bondy",
    "image": "/media/photos/hero.jpg",
    "url": "https://leparadis-bondy.fr",
    "telephone": "+33141552585",
    "priceRange": "1€-10€",
    "menu": "https://leparadis-bondy.fr/#menu",
    "servesCuisine": ["Pizza", "Italian", "Mediterranean", "Burgers"],
    "acceptsReservations": "True",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "43 Av. du Maréchal de Lattre de Tassigny",
      "addressLocality": "Bondy",
      "postalCode": "93140",
      "addressCountry": "FR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 48.9024,
      "longitude": 2.4833
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ],
        "opens": "11:00",
        "closes": "23:30"
      }
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "24"
    }
  };

  return (
    <Helmet>
      <html lang="fr" />
      <title>Le Paradis – Pizzeria Bondy | Pizza, Burgers & Livraison</title>
      <meta name="description" content="Le Paradis, votre pizzeria artisanale à Bondy (93). Pizzas fraîches, burgers gourmands, plats méditerranéens. Commandez sur Uber Eats. Tél : 01 41 55 25 85" />
      <meta name="keywords" content="pizzeria bondy, pizza bondy, restaurant bondy, livraison pizza 93, le paradis bondy, burger bondy, uber eats bondy" />
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Le Paradis Bondy" />
      
      {/* Open Graph */}
      <meta property="og:type" content="restaurant" />
      <meta property="og:title" content="Le Paradis – Pizzeria Bondy" />
      <meta property="og:description" content="Pizzeria artisanale à Bondy. Pizzas fraîches, burgers, commandez sur Uber Eats." />
      <meta property="og:image" content="/media/photos/hero.jpg" />
      <meta property="og:url" content="https://leparadis-bondy.fr" />
      <meta property="og:locale" content="fr_FR" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Le Paradis – Pizzeria Bondy" />
      <meta name="twitter:description" content="Pizzeria artisanale à Bondy. Pizzas fraîches, burgers, livraison." />
      <meta name="twitter:image" content="/media/photos/hero.jpg" />
      
      {/* Geo */}
      <meta name="geo.region" content="FR-93" />
      <meta name="geo.placename" content="Bondy" />
      <meta name="geo.position" content="48.9024;2.4833" />
      <meta name="ICBM" content="48.9024, 2.4833" />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default SEOHead;
